import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box, } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';



const ResourceChart = ({ height, width, criteriaDate, selectedProject }) => {

    const [resorceData, setResorceData] = useState({});
    const [loading, setLoading] = useState(true);
    const [max, setMax] = useState(0);


    useEffect(() => {
        const fetchData = async () => {

            const date = new Date(criteriaDate)
            try {

                if (selectedProject) {
                    const response = await axios.get(`/getoverallresource?project=${selectedProject}&date=${date}`);
                    if (response.data.success) {
                        setMax(
                            _.maxBy(response.data.filledMonthProgress,"cumulativePV").cumulativePV, 
                      
                        
                        )
                        setResorceData({ weekProgress: response.data.filledWeekProgress, monthProgress: response.data.filledMonthProgress });
                    } else {
                        setResorceData({})
                    }
                    setLoading(false);
                }

            } catch (error) {
                setResorceData(null)
                setLoading(false);

                console.error(`데이터 가져오기 중 오류 발생:`, error);
                return []; // 오류 발생 시 빈 배열 반환
            }
        };
        fetchData();
    }, [criteriaDate, selectedProject]);

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // 수평 중앙 정렬
                    alignItems: 'center',     // 수직 중앙 정렬
                    height: '100%',           // 부모 컨테이너의 전체 높이 사용
                }}
            >
                <Circles ariaLabel="loading" color="#00BFFF" height={50} width={50} />
            </Box>
        );
    }

  
        return (
            <ProgressChartWithTitle
                height={height}
                width={width}
                title={"Overall Resource"}
                chartData={resorceData}
                unit={"MD"}
                chart_id={"overallresource"}
                maxYaxis={max * 1.2}
                colors={['#C6C6C6','#A05195']}


            />
        );


  
};

export default ResourceChart

